import { render, staticRenderFns } from "./option-wrapper.vue?vue&type=template&id=735c6174&scoped=true&"
import script from "./option-wrapper.vue?vue&type=script&lang=ts&"
export * from "./option-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./option-wrapper.vue?vue&type=style&index=0&id=735c6174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c6174",
  null
  
)

export default component.exports